import { Component, OnInit, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { SharedService } from '../common/services/sharedService';
import { EmitterService } from '../common/services/emitter.service';
import { PopupComponent } from '../common/utilities/popup/popup.component';
import { Formatter } from '../common/services/formatter';
import { RouteHandlerService } from '../common/services/routeHandler.service';
import { DataLayerService } from '../common/services/dataLayer.service';
import { ActivitiHandlerService } from '../common/services/activitiHandler.service';
import { HttpClient } from '@angular/common/http';
import { RequestOptions, ResponseContentType,Headers} from '@angular/http';
import { HomeService } from '../home/home.service';

@Component({
  selector: 'app-esign',
  templateUrl: './esign.component.html',
  styleUrls: ['./esign.component.css']
})
export class EsignComponent implements OnInit {

  public DocumentList: any;
  public IsViewPdf: boolean;
  public PrivewSource = '';
  public STPFlag = true;
  public isOptGuaranteeChecked = false;
  public config = <CustomModalOptions>{ show: false, backdrop: 'static', closeOption: true };
  public Config = { show: false, backdrop: 'static' };
  public DocumentPreviewPopUpData: any = {};
  public EsignDetailsPopUpData: any = {};
  public Fees = 0;
  public IsPDF = false;
  public ShowLoader = false;
  public ShowBackLoader = false;
  public ExistingCust = false;
  // public appUtmSource: any;
  public disable_preview_eSign = true;
  public IsEmailPresent = false;
  public ShowDocLoader = -1;
  public IsPriviewSource = false;
  public preventNavigation = false;

  private loanApplicationId: string;
  private contentType: string;
  private documentList: any;
  public esignApplicationId = null;

  @ViewChildren(PopupComponent) public popupComponent;
  @ViewChildren(PopupComponent) public popupComponentInstances: QueryList<any>;
  private pdfSource: string;
    isLinkExpired: boolean;
    isError: boolean;
    customError: string;

  constructor(
      private _activitiHandler: ActivitiHandlerService,
      private _routeContextProvider: RouteContextProvider,
      private _sharedService: SharedService,
      private _formatter: Formatter,
      private _dataLayerService: DataLayerService,
      private _routerService: RouteHandlerService,
      private _cookieHandler: CookieHandlerService,
      private _http: HttpClient,
      private _homeService: HomeService

  ) {
    //   this.AfterLoadComplete = this.AfterLoadComplete.bind(this);
  }

  public ngOnInit() {
      this.esignApplicationId = this._routeContextProvider.GetQueryParams
      (CommonConstants.QueryParamsKeys.EsignAppId)
      this.authenticateSystem();
      // let utm_source = this._sharedService.getData(CommonConstants.QueryParamsKeys.appUtmSource);
      // let checkUtmSource = utm_source.search('@');
      // this.IsEmailPresent = (checkUtmSource === -1) ? false : true;
      this.loanApplicationId = this._sharedService.getData('LoanApplicationId');
      
    //   this.setDocumentList();
      this.intializePopupData();
  }

  public verifyEmandate(){
    this.isLinkExpired = false;
      //validateEsign
      let reqData = {
        "authToken": this.esignApplicationId
      }
     this._activitiHandler.GetEsignDetails(reqData,true).subscribe((mtResponse) => {
       console.log("mtResponse",mtResponse);
       let response = mtResponse;
        // let response =  {"payload":{"validationStatus":"ESIGN INITIATED","message":"Link is verified and ESign is initiated","mobileNumber":"7276806030","docList":[{"name":"Application Form","url":"https://bfl-npq-dms-application-bucket.s3-ap-southeast-1.amazonaws.com/APPLICATION_270823/APPLICATION_FORM_063d52c1-2e3d-4ed3-a356-e17db4074dbe_484000000.pdf?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEK%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLXNvdXRoZWFzdC0xIkYwRAIgbEzfi9Ty4mzC8qqpewDd8f38hDTh9u%2Fo31oUikobBXgCIGMagPT%2BCXIniP3D6gmL8KxRzAZ2OqPW%2Bu26aHW8jYUgKv4DCLj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQAhoMNzgzODAxNzQwMTk3Igw2JRgmz43c1p5YYX0q0gNwR4BFPoPe1OR5G7yBm7BxjjYXKRuXXrhI0SduYB9E5fUCEUtLqrPrOgWf0zH25v2Aqxs33rfS9BOhWnnmE7%2FeV5l%2Bdq1zHO4eAYQjNg9W0csMRW%2B7vAmyNtS%2B4HwA8XOt0F7ficB%2FIrjy5eiwptZxX5kZsqSPwd8RQVAMWnqN7LPvyXoEXv9ctqO6sqL%2FINx0C1%2BG09lRxkCAzk26n0KGLPkOA6%2FSbVRX8umIfv5vt%2Bx%2F0AAdcVkJcjwzrE%2FP36IbdqbRwH9f9Eird0M9amZ3FMH7zUwd4taPy75h2PcmqlonGz%2B59JQxXTJ7Sv8pYOO6qrp%2BCwweAmlyWE2X7zV1sJhMR2rw3AcZW3R6aGuTTRbrnNqnEx5LDMGjq8AqZ873NinX3xgFl25w%2BLTHWOjDoIXXSxEZzxuh1bgK%2B7nPdH%2BPwVK4IVqApwvyuWcfrwcfBDgj1laZRtYgdsPl8imofAjJ1U5Pjq0UJchS14E9k4rhjlLul89t%2Fe8M16%2Bkg4GtlZDeCiDOiOBWOoH2kqPmtY576z3Gah%2FArQEylrAMv61NgJ9vkzAsf3y6B%2BIRYAzlNlA5nGfDBpXXln0gffFW27xXIWCNAXBS6pNkunsm%2FJvEMJTPsPQFOvABgDB%2BnLiRVygj6x3jO1hUvfuImbjzpJRj0NjlTWw%2Bsg9U8PnJhTl5U%2F9hwlqb2hQKFqdP60gfVg1qU93pjh8eB%2FKSpN%2F9%2B7bib7GghlfZrSF6q5HNlpEYnP1rGH%2Ft4iWYsa57K7%2B1oXrN5E4wCXPw%2FLFFXp2URQExuSpIhy%2FNSGnmSx9yzOy14T50bLIpVTW1rg6mbX7y%2FWpC4pxJpWn5GPEhgnSMNHX3cvLuA%2BCoaHji4pbjDoCM853VnhvbiyFyjFT219awTMlltHZsPeymTiCtWTvd33JgjOODy6RH0rKBDdXElYX0CBwJe2sTD0bq&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20200407T100812Z&X-Amz-SignedHeaders=host&X-Amz-Expires=604800&X-Amz-Credential=ASIA3M7RZNOS45WAZRGK%2F20200407%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Signature=e381816a8e586945d2aeb287d16daec0589a6de9b7cbaf2cea652ef3e61b35c4","urlKey":"APPLICATION_270823/APPLICATION_FORM_063d52c1-2e3d-4ed3-a356-e17db4074dbe_484000000.pdf","docId":null,"type":"APPLICATION_FORM","category":null,"typeDesc":"Application Form","contentType":"application/pdf","submitStatus":"1","legalDeskDocId":"","downloadable":"1","verificationStatus":"1","esignSequence":0,"originalCopyFlag":false,"docCategoryCode":null,"docCategoryDesc":null,"docName":"Prof_Loan_Application.pdf","custDoc":null,"documentFor":null},{"name":"Consolidated eSign Document","url":"https://bfl-npq-dms-application-bucket.s3-ap-southeast-1.amazonaws.com/APPLICATION_270823/CONS_ESIGN_DOC_33e43b54-d710-4c8f-ad15-ebbf916e52ab_843000000.pdf?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEK%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLXNvdXRoZWFzdC0xIkYwRAIgbEzfi9Ty4mzC8qqpewDd8f38hDTh9u%2Fo31oUikobBXgCIGMagPT%2BCXIniP3D6gmL8KxRzAZ2OqPW%2Bu26aHW8jYUgKv4DCLj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQAhoMNzgzODAxNzQwMTk3Igw2JRgmz43c1p5YYX0q0gNwR4BFPoPe1OR5G7yBm7BxjjYXKRuXXrhI0SduYB9E5fUCEUtLqrPrOgWf0zH25v2Aqxs33rfS9BOhWnnmE7%2FeV5l%2Bdq1zHO4eAYQjNg9W0csMRW%2B7vAmyNtS%2B4HwA8XOt0F7ficB%2FIrjy5eiwptZxX5kZsqSPwd8RQVAMWnqN7LPvyXoEXv9ctqO6sqL%2FINx0C1%2BG09lRxkCAzk26n0KGLPkOA6%2FSbVRX8umIfv5vt%2Bx%2F0AAdcVkJcjwzrE%2FP36IbdqbRwH9f9Eird0M9amZ3FMH7zUwd4taPy75h2PcmqlonGz%2B59JQxXTJ7Sv8pYOO6qrp%2BCwweAmlyWE2X7zV1sJhMR2rw3AcZW3R6aGuTTRbrnNqnEx5LDMGjq8AqZ873NinX3xgFl25w%2BLTHWOjDoIXXSxEZzxuh1bgK%2B7nPdH%2BPwVK4IVqApwvyuWcfrwcfBDgj1laZRtYgdsPl8imofAjJ1U5Pjq0UJchS14E9k4rhjlLul89t%2Fe8M16%2Bkg4GtlZDeCiDOiOBWOoH2kqPmtY576z3Gah%2FArQEylrAMv61NgJ9vkzAsf3y6B%2BIRYAzlNlA5nGfDBpXXln0gffFW27xXIWCNAXBS6pNkunsm%2FJvEMJTPsPQFOvABgDB%2BnLiRVygj6x3jO1hUvfuImbjzpJRj0NjlTWw%2Bsg9U8PnJhTl5U%2F9hwlqb2hQKFqdP60gfVg1qU93pjh8eB%2FKSpN%2F9%2B7bib7GghlfZrSF6q5HNlpEYnP1rGH%2Ft4iWYsa57K7%2B1oXrN5E4wCXPw%2FLFFXp2URQExuSpIhy%2FNSGnmSx9yzOy14T50bLIpVTW1rg6mbX7y%2FWpC4pxJpWn5GPEhgnSMNHX3cvLuA%2BCoaHji4pbjDoCM853VnhvbiyFyjFT219awTMlltHZsPeymTiCtWTvd33JgjOODy6RH0rKBDdXElYX0CBwJe2sTD0bq&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20200407T100812Z&X-Amz-SignedHeaders=host&X-Amz-Expires=604800&X-Amz-Credential=ASIA3M7RZNOS45WAZRGK%2F20200407%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Signature=72e22fd1ccfc08ab59ce478fc368a533018f462bb8db519e5be278161c26f02a","urlKey":"APPLICATION_270823/CONS_ESIGN_DOC_33e43b54-d710-4c8f-ad15-ebbf916e52ab_843000000.pdf","docId":null,"type":"CONS_ESIGN_DOC","category":null,"typeDesc":"Consolidated eSign Document","contentType":"application/pdf","submitStatus":"1","legalDeskDocId":"","downloadable":"1","verificationStatus":"1","esignSequence":0,"originalCopyFlag":false,"docCategoryCode":null,"docCategoryDesc":null,"docName":"313000000.pdf","custDoc":null,"documentFor":null},{"name":"Loan Agreement","url":"https://bfl-npq-dms-application-bucket.s3-ap-southeast-1.amazonaws.com/APPLICATION_270823/LOAN_AGREEMENT_b1e6a043-3213-45cf-b605-b93ba72ffca7_309000000.pdf?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEK%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDmFwLXNvdXRoZWFzdC0xIkYwRAIgbEzfi9Ty4mzC8qqpewDd8f38hDTh9u%2Fo31oUikobBXgCIGMagPT%2BCXIniP3D6gmL8KxRzAZ2OqPW%2Bu26aHW8jYUgKv4DCLj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQAhoMNzgzODAxNzQwMTk3Igw2JRgmz43c1p5YYX0q0gNwR4BFPoPe1OR5G7yBm7BxjjYXKRuXXrhI0SduYB9E5fUCEUtLqrPrOgWf0zH25v2Aqxs33rfS9BOhWnnmE7%2FeV5l%2Bdq1zHO4eAYQjNg9W0csMRW%2B7vAmyNtS%2B4HwA8XOt0F7ficB%2FIrjy5eiwptZxX5kZsqSPwd8RQVAMWnqN7LPvyXoEXv9ctqO6sqL%2FINx0C1%2BG09lRxkCAzk26n0KGLPkOA6%2FSbVRX8umIfv5vt%2Bx%2F0AAdcVkJcjwzrE%2FP36IbdqbRwH9f9Eird0M9amZ3FMH7zUwd4taPy75h2PcmqlonGz%2B59JQxXTJ7Sv8pYOO6qrp%2BCwweAmlyWE2X7zV1sJhMR2rw3AcZW3R6aGuTTRbrnNqnEx5LDMGjq8AqZ873NinX3xgFl25w%2BLTHWOjDoIXXSxEZzxuh1bgK%2B7nPdH%2BPwVK4IVqApwvyuWcfrwcfBDgj1laZRtYgdsPl8imofAjJ1U5Pjq0UJchS14E9k4rhjlLul89t%2Fe8M16%2Bkg4GtlZDeCiDOiOBWOoH2kqPmtY576z3Gah%2FArQEylrAMv61NgJ9vkzAsf3y6B%2BIRYAzlNlA5nGfDBpXXln0gffFW27xXIWCNAXBS6pNkunsm%2FJvEMJTPsPQFOvABgDB%2BnLiRVygj6x3jO1hUvfuImbjzpJRj0NjlTWw%2Bsg9U8PnJhTl5U%2F9hwlqb2hQKFqdP60gfVg1qU93pjh8eB%2FKSpN%2F9%2B7bib7GghlfZrSF6q5HNlpEYnP1rGH%2Ft4iWYsa57K7%2B1oXrN5E4wCXPw%2FLFFXp2URQExuSpIhy%2FNSGnmSx9yzOy14T50bLIpVTW1rg6mbX7y%2FWpC4pxJpWn5GPEhgnSMNHX3cvLuA%2BCoaHji4pbjDoCM853VnhvbiyFyjFT219awTMlltHZsPeymTiCtWTvd33JgjOODy6RH0rKBDdXElYX0CBwJe2sTD0bq&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20200407T100812Z&X-Amz-SignedHeaders=host&X-Amz-Expires=604800&X-Amz-Credential=ASIA3M7RZNOS45WAZRGK%2F20200407%2Fap-southeast-1%2Fs3%2Faws4_request&X-Amz-Signature=51316ba64851704c83074d5857f73311a08848d1da6c6136ab553dd579415fe4","urlKey":"APPLICATION_270823/LOAN_AGREEMENT_b1e6a043-3213-45cf-b605-b93ba72ffca7_309000000.pdf","docId":null,"type":"LOAN_AGREEMENT","category":null,"typeDesc":"Loan Agreement","contentType":"application/pdf","submitStatus":"1","legalDeskDocId":"","downloadable":"1","verificationStatus":"1","esignSequence":0,"originalCopyFlag":false,"docCategoryCode":null,"docCategoryDesc":null,"docName":"Prof_Loan_E_Agreement.pdf","custDoc":null,"documentFor":null},{"name":"Mandate","url":null,"urlKey":null,"docId":null,"type":"MANDATE","category":null,"typeDesc":"Mandate","contentType":null,"submitStatus":"0","legalDeskDocId":"","downloadable":"1","verificationStatus":"0","esignSequence":0,"originalCopyFlag":false,"docCategoryCode":null,"docCategoryDesc":null,"docName":null,"custDoc":null,"documentFor":null}]},"status":"SUCCESS","errorBean":null}
        // console.log("mtResponse esign validate",response);
        if (!response.errorBean) {            
        this._cookieHandler.SetCookie("esignMobile",response.payload.mobileNumber);
            this.disable_preview_eSign = false;
            if(response.payload && response.payload.validationStatus == "ESIGN INITIATED"){
                this.getModalDirectiveInstanceBasedOnId('eSignDetails').show();
                this.DocumentList = response.payload.docList;
            } else if(response.payload && response.payload.validationStatus == "SUCCESS"){
                this.getModalDirectiveInstanceBasedOnId('eSignDetails').show();
                this._sharedService.setData("eOtpData",response.payload.docList);
                    // this.routeToNextRoute(CommonConstants.Routes.EsignThankYou);
                    this._routeContextProvider.NavigateToViewEsign([CommonConstants.Routes.EsignThankYou]);
            } else if(response.payload && response.payload.validationStatus == "FAILURE"){
                this.isLinkExpired = true;
                this.disable_preview_eSign = true;
            }else {
                this.disable_preview_eSign = true;
                this.isError = true;
                this.customError = "Something went Wrong";
            }
        }else{
                this.disable_preview_eSign = true;
                this.isError = true;
                this.customError = mtResponse.errorBean[0].errorMessage;
        }
        console.log("new doc list", this.DocumentList);
        if(response.payload){
            this._sharedService.setData("esignData",response.payload);
        }
   });
  }

  public downloadEsignDocument(doc){
      console.log("doc",doc);
      if(doc.url){
        window.open(doc.url, '_blank');
      }
      
  }
  public sendToOtp(){  
    this._routeContextProvider.NavigateToViewEsign([CommonConstants.Routes.EsignOtp]);
  }
  
  private authenticateSystem(): void {
    const userClientId = this._homeService.GetClientIdForUser();
    this.setSecretKeyForClientId(userClientId);
}
private setSecretKeyForClientId(clientId: string): void {
    this._homeService.GetSecretKeyForBasedOnClientId(clientId).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
        if (!responseData.errorBean) {
            this._cookieHandler
                .SetCookie(CommonConstants.CookieKeys.ClientId, clientId);
            this._cookieHandler
                .SetCookie(CommonConstants.CookieKeys.SecretKey,
                    responseData.payload.secretKey);
            this.setSystemAuthToken(responseData.payload.secretKey, clientId);
        }
    });
}
private setSystemAuthToken(secretKey: string, clientId: string): void {
    this._homeService.GetSystemAuthToken({
        secretKey,
        clientId
    }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
        if (!responseData.errorBean) {
            const tokenObj = responseData.payload.tokens[0];
            console.log('tokens::', tokenObj);
            this._cookieHandler.SetCookie(CommonConstants.CookieKeys.JWToken, tokenObj.token);
            this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
            this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardToken, this._formatter
                .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
                this.verifyEmandate()
        }
    });
}
  
  public PrintDocument(url) {
      if (this._cookieHandler.GetCookie
          (CommonConstants.CookieKeys.MobileState) !== '1') {
          this._routeContextProvider.NavigateToView(url, '_blank');
      } else {
          window.open(url, '_system');
      }
  }
 

 

  public OnBack() {
      this.ShowBackLoader = true;
      this._activitiHandler.MarkTaskAsCompleted(
          null,
          'Back',
          true).subscribe((mtResponse) => {
              if (!mtResponse.errorBean) {
                  this.routeToNextRoute(mtResponse.nextTaskKey);
              }
          });
  }

  public OnCancle() {
      this._activitiHandler.MarkTaskAsCompleted(null, 'Skipped', true).subscribe((mtResponse) => {
          if (!mtResponse.errorBean) {
              this.routeToNextRoute(mtResponse.nextTaskKey);
          }
      });
  }
  public hidePopUp($event) {
      this.config.show = false;
      // console.log('this.popupComponent:', this.popupComponent);
      // this.popupComponent.HideModalDialog(event);
      this.getModalDirectiveInstanceBasedOnId(
          $event.currentTarget.attributes['data-target'].value).hide();
  }
  public ShowBundlePopupUp($event: any): void {
      this.getModalDirectiveInstanceBasedOnId(
          $event.currentTarget.attributes['data-target'].value).show();
  }

  public SignPhysically() {
      this._activitiHandler.MarkTaskAsCompleted(null, 'Skipped', true).subscribe((mtResponse) => {
          if (!mtResponse.errorBean) {
              this.routeToNextRoute(mtResponse.nextTaskKey);
          }
      });
  }

  private routeToNextRoute(nextTaskKey) {
      nextTaskKey = this._formatter.toSmallCase(nextTaskKey);
      this._routerService.RouteToNextTask(nextTaskKey);
  }

  private getModalDirectiveInstanceBasedOnId(popupId: string): any {
      return this.popupComponentInstances.filter((item: PopupComponent) => {
          return item.id === popupId;
      })[0].modalControl;
  }  


  private intializePopupData() {
      this.DocumentPreviewPopUpData = {
          Id: 'documentPreview',
          Config: <CustomModalOptions>{ show: false },
      };

      this.EsignDetailsPopUpData = {
          Id: 'eSignDetails',
          Config: <CustomModalOptions>{ show: true },

      };
  }

}
